module.exports = __webpack_public_path__ + "img/special-beers.fb069d76.png";